// Stub: SEO now handled per-route via TanStack Router head().
const SEOHead = (_props: { title?: string; description?: string; canonical?: string }) => null;
export default SEOHead;
